export default __webpack_public_path__ + "static/media/39_desktop.5e5496a6.jpeg";